/**
 * Comparators that tolerate a malformed/partial record instead of throwing.
 * Production will accumulate real data with edge cases the UI hasn't been
 * exercised against — a single record missing a sorted field must degrade
 * (sort to one end) rather than crash the whole list mid-render.
 */

export function compareByString<T>(getField: (item: T) => unknown, direction: 'asc' | 'desc' = 'asc') {
  return (a: T, b: T): number => {
    const av = getField(a);
    const bv = getField(b);
    const cmp = (typeof av === 'string' ? av : '').localeCompare(typeof bv === 'string' ? bv : '');
    return direction === 'asc' ? cmp : -cmp;
  };
}

export function compareByNumber<T>(getField: (item: T) => unknown, direction: 'asc' | 'desc' = 'asc') {
  return (a: T, b: T): number => {
    const av = getField(a);
    const bv = getField(b);
    const an = typeof av === 'number' && Number.isFinite(av) ? av : 0;
    const bn = typeof bv === 'number' && Number.isFinite(bv) ? bv : 0;
    return direction === 'asc' ? an - bn : bn - an;
  };
}
